// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-main-page[data-v-80e5dcfa] {\n  width: 100%;\n  padding: 60px;\n}\nh2[data-v-80e5dcfa] {\n  margin-bottom: 24px;\n}\n.field-label[data-v-80e5dcfa] {\n  width: 300px;\n}\n.field-value[data-v-80e5dcfa] {\n  width: 450px;\n}\n.field-value a[data-v-80e5dcfa] {\n  color: #009bff;\n}\n.field-value a[data-v-80e5dcfa]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
